import * as Yup from 'yup'

export const initialValues = {
    whatIsNeeded: '',
    fromDate: '',
    toDate: '',
    howMany: 1,
    deliverToAccountId: '',
}

export const validationSchema = Yup.object().shape({
    whatIsNeeded: Yup.string()
        .required('What is needed is required')
        .max(255, 'Description too long (maximum 255 characters)'),
    fromDate: Yup.date(),
    toDate: Yup.date().when(
        'fromDate',
        (fromDate, Yup) =>
            fromDate &&
            Yup.min(fromDate, 'From date must be prior to or same as To date'),
    ),
    howMany: Yup.number()
        .required('How many is required')
        .min(0, 'Must be more than 0'),
    deliverToAccountId: Yup.string().required('The location is required'),
})
